module.exports = __webpack_public_path__ + "public/media/2.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/partners/2.jpg
// module id = ./images/partners/2.jpg
// module chunks = 0